module.exports = __webpack_public_path__ + "img/employess.c0e0d9ec.svg";